export default __webpack_public_path__ + "static/media/hero-image.f1cb6a1c.svg";